var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pixi-renderer"},[_c('canvas',{ref:"renderCanvas",staticClass:"max-w-full max-h-full mx-auto shadow-lg overflow-hidden rounded-lg",staticStyle:{"width":"480px"}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }